
const userListColumn = [
    {
        name: "Date",
        selector: row => row?.creat_dt,
    },
    {
        name: "Device Name",
        selector: row => row?.device_name_tx,
    },
    {
        name: "Platform",
        selector: row => row?.platform_tx,
    },
    {
        name: "Type",
        selector: row => row?.type_tx,
    },
    {
        name: 'Notes',
        selector: row => row?.note_tx,
    },
    
]

const userListMobileColumn = [
    {
        name: "",
        cell: row => (
            <div>
                <p><span className='fw-bold'>Date :</span>{row?.creat_dt}</p>
                <p><span className='fw-bold'>Device Name :</span>{row?.name_tx}</p>
                <p><span className='fw-bold'>Platform :</span>{row?.platform_tx}</p>
                <p><span className='fw-bold'>Type :</span>{row?.type_tx}</p>
                <p><span className='fw-bold'>Notes :</span>{row?.note_tx}</p>
            </div>
        ),
    },
]

export { userListColumn,userListMobileColumn }